export const ROUTES = {
  ADMIN_SIGN_IN: 'admin-sign-in',
  AGENCIES: 'agencies',
  AGENCIES_ACTIVE: 'agencies/active/:id',
  AGENCIES_ACTIVE_LIST: 'agencies/active',
  AGENCIES_ADD: 'agencies/invite/add',
  AGENCIES_EDIT: 'agencies/invite/:id/edit',
  AGENCIES_INVITE: 'agencies/invite/:id',
  AGENCIES_INVITE_LIST: 'agencies/invite',
  AGENCIES_REMOVE_LIST: 'agencies/removed',
  AGENCY_CONTRACT_UPDATE: 'agencies/active/:id/edit',
  AGENCY_CONTRACT_V2_CREATE: 'agencies/contracts/new',
  AGENCY_CONTRACT_V2_VIEW: 'agencies/contracts/:id',
  AGENCY_CONTRACT_V2_EDIT: 'agencies/contracts/:id/edit',
  AGENCY_CONTRACT_V2_SCOPE: 'agencies/contracts/:id/scope',
  AGENCIES_INVOICE_LIST: 'agencies/invoices',
  AGENCIES_CONSOLIDATED_INVOICE: 'agencies/invoices/consolidated/:invoiceId',
  DASHBOARD: 'dashboard',
  DASHBOARD_INSIGHTS: 'dashboard/insights',
  FORBIDDEN: 'forbidden',
  NOTIFICATIONS: 'notifications',
  NOTIFICATIONS_ARCHIVE: 'archiveNotifications',
  NO_MATCH: '*',
  ORGANIZATIONS: 'enterprise_organizations',
  ORGANIZATION_CREATE: 'enterprise_organizations/create',
  ORGANIZATION_UPDATE: 'enterprise_organizations/:id/edit',
  ORGANIZATION_VIEW: 'enterprise_organizations/:id',
  PAGE_NOT_FOUND: '404',
  PROFILE: 'profile',
  SETTINGS: 'settings',
  DATA_UPLOADS: 'dataUploads',
  LEGAL_ENTITIES: 'legalEntities',
  LEGAL_ENTITIES_CREATE: 'legalEntities/create',
  LEGAL_ENTITIES_EDIT: 'legalEntities/:id/edit',
  USER_GUIDE: 'user-guide',
  USER_GUIDE_KEY: 'user-guide/*',
  AGENCY_WORKERS: 'agencyWorkers/:id',
  AGENCY_WORKERS_CHECKLIST: 'agencyWorkers/:id/checklists/:checklistId',
  AGENCY_WORKERS_SHIFTS: 'agencyWorkers/:id/:shiftType',
  AGENCY_WORKERS_LIST: 'agencyWorkers',
  AGENCY_WORKERS_CONVERT_TO_PERMANENT: 'workers/:id/convert-to-permanent',
  AGENCY_WORKERS_TASK_REVIEW: 'agencyWorkers/:id/checklists/:checklistId/:taskId',
  INTERVIEWS: 'interviews',
  APPLICANT_INTERVIEWS: 'interviews/:id',
  EDIT_APPLICANT_INTERVIEWS: 'interviews/:id/edit',
  APPLICANT_LIST: 'applicants',
  VIEW_APPLICANT: 'applicants/:id',
  EDIT_APPLICANT: 'applicants/:id/edit',
  APPLICANT_ACCREDITATION: 'applicants/:id/applicantAccreditations/:applicantAccreditationId',
  APPLICANT_SUPERANNUATION: 'applicants/:id/editSuperannuation',
  TALENT_LIST: 'talent',
  VIEW_TALENT: 'talent/:id',
  EDIT_TALENT: 'talent/:id/edit',
  TALENT_ACCREDITATION: 'talent/:id/talentAccreditations/:talentAccreditationId',
  TALENT_SUPERANNUATION: 'talent/:id/talentAccreditations/:talentAccreditationId',
  EDIT_TALENT_SUPERANNUATION: 'talent/:id/editSuperannuation',
  TALENT_PAST_JOBS: 'talent/:id/pastJobs',
  DENIED_TALENT_LIST: 'denied',
  TERMINATED_TALENT_LIST: 'terminated',
  VIEW_DENIED_TALENT: 'denied/:id',
  VIEW_TERMINATED_TALENT: 'terminated/:id',
  EDIT_DENIED_TALENT: 'denied/:id/edit',
  EDIT_TERMINATED_TALENT: 'terminated/:id/edit',
  CHECKLISTS: 'checklists',
  CREATE_CHECKLIST: 'checklists/create',
  EDIT_CHECKLIST: 'checklists/edit/:id',
  RATE_ENGINE_LIST: 'pricing/rate-engine',
  RATE_ENGINE_CREATE: 'pricing/rate-engine/new',
  RATE_ENGINE_VIEW: 'pricing/rate-engine/:id',
  RATE_ENGINE_VERSION_CREATE: 'pricing/rate-engine/:engineId/versions/new',
  // `:id` here is a version id, not an engine id as in RATE_ENGINE_VIEW.
  RATE_ENGINE_EDIT: 'pricing/rate-engine/:id/edit',
  RATE_CARDS: 'pricing/rate-cards',
  RATE_CARDS_CREATE: 'pricing/rate-cards/new',
  RATE_CARDS_VIEW: 'pricing/rate-cards/:id',
  RATE_CARDS_REVIEW: 'pricing/rate-cards/:id/review',
  RATE_SIMULATOR: 'pricing/rate-simulator',
  POSITION_AVAILABILITY: 'pricing/position-availability',
};
